<template>
	<!--帖子标题 -->
	<div class="tieziInfoBox">
		<!-- 头部 -->
		<van-sticky>
			<div class="headerBox">
				<img src="../../assets/img/myicon/indexBgc02.png" alt="" class="backImg">
				<div class="headerQuery">
					<div class="arrImg" @click="backForum">
						<img src="../../assets/img/leftarr_tit.png" alt="">
					</div>
					<p class="header_titile">发表帖子</p>
				</div>
			</div>
		</van-sticky>
		<div class="hot_htBox">
			<div class="scroll_bigBox">
				<div class="scroll_box" ref="scrollWidth">
					<span v-for="(item,idx) in hotTalk" :key="idx" :class="idx == actidx ? 'active' : ''" @click="contentFn(idx,item.content)">{{item.content}}</span>
				</div>
			</div>
			<div class="bottom_bm">
				<input type="text" v-model="title" placeholder="标题">
			</div>
			<div class="content">
				<span v-show="is_content">帖子内容</span>
				<editor-bar v-model="detail" :isClear="isClear" @change="change"></editor-bar>
			</div>
			<div class="fixed_footerBox">
				<!-- <div>
					<img src="../../assets/img/myicon/ltsmile.png" alt="">
					<img src="../../assets/img/myicon/ltimg.png" alt="">
					<img src="../../assets/img/myicon/lticon.png" alt="">
				</div> -->
				<div>
					<div class="radio_nm">
						<van-checkbox v-model="scRadio" checked-color="#ffdd2b" label-position="left">匿名</van-checkbox>
					</div>
					<div class="fb_btn">
						<button @click="add_forum">发表</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import EditorBar from '../../components/wangEnduit.vue'

	export default {
		components: {
			EditorBar
		},
		data() {
			return {
				navBarIndex: 0,
				navbar: ["帖子列表", "热门话题楼"],
				scRadio: false,
				hotTalk: [],
				desc: '',
				title: '',
				isClear: false,
				detail: "",
				actidx:0,
				is_content: true,
			}
		},
		created() {
			this.hot_talk()
		},
		mounted() {
			
		},
		methods: {
			backForum() {
				this.$router.go(-1);
			},
			change(val) {
				this.detail = val;
				var reg = /<\/?.+?\/?>/g;
				var t_content = val.replace(reg,'');
				if(t_content){
					this.is_content = false;
				}else{
					this.is_content = true;
				}
			},
			hot_talk() {
				this.$axios.post(this.$api.hot_talk).then(res => {
					this.hotTalk = res.data.data;
					if(this.hotTalk.length <= 3){
						this.$refs.scrollWidth.style.width = 100 + 'vw';
					}else {
						this.$refs.scrollWidth.style.width= this.hotTalk.length * 100 +'px';
					}
				})
			},
			add_forum() {
				this.$axios.post(this.$api.add_forum, {
					category_id: this.$route.query.categoryDetailId,
					title: this.title,
					content: this.detail,
					anonymous: Number(this.scRadio),
				}).then(res => {
					if(res.data.code == 1){
						this.$toast(res.data.msg);
						this.$router.go(-1);
					}
				})
			},
			contentFn(idx,content){
				this.actidx = idx;
				this.detail = content;
			}
		}
	}
</script>

<style lang="less" scoped>
	.tieziInfoBox {
		background-color: #fff;
		height: 100vh;
		width: 100vw;
		overflow: hidden;

		// 头部
		.headerBox {
			height: 160px;
			background-color: #fff;
			display: flex;
			position: relative;
			
			.backImg{
				position: absolute;
				bottom: 10px;
				left:0;
				width:100%;
			}

			.headerQuery {
				margin-top: 80px;
				padding: 0 20px;
				position: relative;
				display: flex;
				width: 100%;
				height: 80px;
				line-height: 80px;
				color: #000;
				border-bottom: 1px solid #f0f0f0;

				.arrImg {
					img {
						width: 40px;
						position: absolute;
						top: 50%;
						transform: translateY(-50%);
						left: 0px;
					}
				}

				.header_titile {
					flex: 1;
					text-align: center;
					font-size: 34px;
					/*px*/
				}
			}

		}

		//热门话题
		.hot_htBox {
			.scroll_bigBox {
				width: calc(100vw - 40px);
				height: 130px;
				overflow: scroll;
				padding: 0 20px;
				.scroll_box {
					height: 60px;
					padding-top: 40px;
					overflow-x: scroll;
					overflow-y: hidden;
					span {
						border: 1px solid #f5f5f5;/*no*/
						color: #000;
						border-radius: 50px;
						margin-right: 20px;
						width: 200px;
						height: 50px;
						line-height: 50px;
						text-align: center;
						display: inline-block;
						overflow: hidden;
						background-color: #f5f5f5;
					}
					.active{
						background-color: #ffdd2b;
						color: #fff;
					}
				}
			}

			.bottom_bm {
				border-top: 1px solid #f0f0f0;
				/*no*/
				border-bottom: 1px solid #f0f0f0;
				/*no*/
				line-height: 80px;
				margin: 0 16px;
				display: flex;

				span {
					font-weight: 600;
					font-size: 30px;
					/*px*/
					color: #bcbcbc;
				}

				input {
					font-size: 34px !important;
					/*px*/
					flex: 1;
					padding-left: 20px;
					color: #000;
					font-weight: bold;
				}
				input::placeholder{
					// color: #000;
					font-size: 34px !important;
					font-weight: normal;
					/*px*/
				}
			}

			.content {
				position: relative;
				margin-top:20px;
				
				span {
					font-size: 30px;
					/*px*/
					line-height: 46px;
					padding-left: 20px;
					color: #D3D3D3;
					position: absolute;
					top:72px;
					left:15px;
				}
				/deep/ .w-e-text{
					padding:0 20px 0 36px;
					
					/deep/  p{
						font-size: 34px;
						color: #000;
					}
				}
				.textareaBox {
					position: relative;
					padding-bottom: 30px;

					textarea {
						padding-top: 10px;
						width: calc(100vw - 32px);
						border: 0;
						height: 150px;
						color: #3d3d3d;
						text-indent: 1em;

						&::placeholder {
							font-size: 24px;
							/*px*/
						}
					}
				}
			}

			.fixed_footerBox {
				position: fixed;
				bottom: 0;
				left: 50%;
				width: calc(50vw - 40px);
				padding: 20px;
				// width: calc(100vw - 40px);
				display: flex;

				div {
					flex: 1;

					img {
						width: 50px;
						height: 50px;
						margin-right: 30px;
					}
				}

				div {
					flex: 1;
					display: flex;

					.radio_nm {
						flex: 1;
						text-align: right;

						/deep/.van-radio-group {
							/deep/.van-radio__icon .van-icon {
								width: 30px;
								height: 30px;
								line-height: 30px;
								font-size: 24px;
							}

							/deep/.van-radio__label {
								font-size: 22px;
								/*px*/
							}
						}
					}

					.fb_btn {
						flex: 1;
						position: relative;

						button {
							border: 0;
							background-color: #ffdd2b;
							color: #fff;
							height: 50px;
							/*px*/
							line-height: 50px;
							/*px*/
							width: 150px;
							border-radius: 50px;
							position: absolute;
							top: 50%;
							left: 50%;
							transform: translate(-50%, -50%);
						}
					}
				}
			}
		}
	}
</style>
